// src/lib/supabase.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://hbvfexuqkbegdarifgzi.supabase.co";
const supabaseAnonKey =
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhidmZleHVxa2JlZ2RhcmlmZ3ppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxNTM4MDYsImV4cCI6MjA2NzcyOTgwNn0.UWdXEPURaJalax5PjOsPEjllfvFySdrixxcsYbKBIY0";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
